/* ============================================================
   SOLARA: New drops
   Scroll reveals, pointer tilt + glow (fine pointers only), phone
   carousel progress, and quick add through the theme's cart flow
   (window.SolaraAddons.addItems from assets/solara-addons.js).
   Reduced motion: no reveals, no tilt. Safe to load more than once.
   ============================================================ */
(function () {
  if (window.SolaraNewDrops) {
    window.SolaraNewDrops.scan(document);
    return;
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var setupReveal = function (root) {
    var targets = root.querySelectorAll('[data-snd-reveal], [data-snd-grid]');
    if (!root.hasAttribute('data-snd-motion') || reduce || !hasIO) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.18 });
    targets.forEach(function (t) { io.observe(t); });
  };

  var setupTilt = function (root) {
    if (!root.hasAttribute('data-snd-tilt-on') || reduce || !fine) return;
    root.querySelectorAll('[data-snd-tilt]').forEach(function (card) {
      var frame = null;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var amp = Math.min(1, 380 / r.width);      /* big cards tilt less */
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          card.classList.add('is-tilting');
          card.style.setProperty('--ry', ((px - 0.5) * 8 * amp).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - py) * 7 * amp).toFixed(2) + 'deg');
          card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', function () {
        if (frame) cancelAnimationFrame(frame);
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  };

  var setupProgress = function (root) {
    var grid = root.querySelector('[data-snd-grid]');
    var bar = root.querySelector('[data-snd-progress]');
    if (!grid || !bar) return;
    var update = function () {
      var max = grid.scrollWidth - grid.clientWidth;
      var visible = grid.scrollWidth ? grid.clientWidth / grid.scrollWidth : 1;
      var p = max > 0 ? grid.scrollLeft / max : 1;
      bar.style.width = Math.min(100, (visible + (1 - visible) * p) * 100).toFixed(1) + '%';
    };
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  var setupAdd = function (root) {
    var msg = root.querySelector('[data-snd-msg]');
    root.querySelectorAll('[data-snd-add]').forEach(function (btn) {
      var label = btn.querySelector('[data-snd-label]');
      var original = label ? label.textContent : '';
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        var id = Number(btn.getAttribute('data-variant-id'));
        if (!id) return;
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Adding';
        var add = window.SolaraAddons && window.SolaraAddons.addItems
          ? window.SolaraAddons.addItems([{ id: id, quantity: 1 }], btn, true)
          : fetch('/cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
            }).then(function (r) {
              if (!r.ok) throw new Error('Could not add to cart.');
              window.location.href = '/cart';
            });
        add.then(function () {
          btn.classList.add('is-added');
          if (label) label.textContent = 'Added';
          if (msg) msg.textContent = 'Added to your cart.';
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label) label.textContent = original;
          }, 2500);
        }).catch(function (err) {
          if (label) label.textContent = original;
          if (msg) msg.textContent = (err && err.message) || 'Could not add to cart.';
        }).then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  };

  var scan = function (scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-snd]').forEach(function (root) {
      if (root.__snd) return;
      root.__snd = true;
      setupReveal(root);
      setupTilt(root);
      setupProgress(root);
      setupAdd(root);
    });
  };

  window.SolaraNewDrops = { scan: scan };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
